<template>
    <div :class="{'container-dark': theme_dark}">
        <div class="nav-top">
            <div class="nav-left" @click="back()">
                <img src="../../assets/img/返回箭头.png" class="nav-img">
                <span class="nav-lable"></span>
            </div>
            <div class="nav-middle">修改位置信息</div>
            <div class="nav-right">
                <span class="nav-lable" @click="save()">保存</span>
                <img src="../../assets/img/返回箭头.png" class="nav-img none">
            </div>
        </div>

        <div class="loc">
            <v-distpicker :province="user.loc_province" :city="user.loc_city" :area="user.loc_area" @selected='locSelected' type="mobile"></v-distpicker>
        </div>

        <alert ref="myConfirm"></alert>
    </div>
</template>

<script>
    import * as tool from "../../api/common";
    import Alert from '../../components/Alert.vue';
    import { mapMutations, mapActions } from "vuex";
    export default {
        components: {
            'alert': Alert
        },
        data() {
            return {
                user: {
                    loc_province: "湖北省",
                    loc_city: "武汉市",
                    loc_area: "武昌区"
                },
                theme_dark: false
            }
        },
        mounted() {
            //切换深色模式
            this.theme_dark = tool.is_theme_dark(this);
            this.init_page();
        },
        methods: {
            ...mapMutations(["get", "post", "upload"]), //引入方法
            ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
            back() {
                this.$router.go(-1);//返回上一层
            },

            init_page() {
                var uid = this.$store.state.uid;
                var self = this;

                self.act_get_userinfo({
                    uid: uid,
                    success: function (u) {
                        self.user.loc_province = u.loc_province;
                        self.user.loc_city = u.loc_city;
                        self.user.loc_area = u.loc_area;
                    }
                });
            },


            locSelected(data) {
                var province = data.province.value;
                var city = data.city.value;
                var area = data.area.value;

                this.user.loc_province = province;
                this.user.loc_city = city;
                this.user.loc_area = area;
            },

            save() {
                var province = this.user.loc_province;
                var city = this.user.loc_city;
                var area = this.user.loc_area;

                if (province == '省' || city == '市' || area == '区') {
                    this.$refs.myConfirm.show('请先选择完整位置信息', {
                        type: 'alert',
                        confirmText: '确定',
                        titleText: '温馨提示',
                        data: ''
                    })
                    return false;
                }

                //保存位置信息
                var send_data = this.user;
                this.save_serve(send_data);
            },

            save_serve(send_data) {
                //后台保存信息
                var self = this;
                var uid = this.$store.state.uid;
                //var send_data = {'nick' : nick};
                var data = {
                    url: '/App/User_ModifyBaseInfo',
                    data: {
                        'uid': uid,
                        'data': JSON.stringify(send_data)
                    },
                    success: function (data_serve) {
                        if (data_serve.state == '1') {
                            self.act_reload_userinfo({
                                'uid': uid,
                                success: function (info) {
                                    self.init_page();
                                    self.back();
                                }
                            })
                        }
                    }
                }
                self.post(data);
            }

        }
    }
</script>

<style lang="scss" scoped>
.loc {
    font-size: .8rem;
    margin-top: .8rem;
}
.container-dark {
    min-height: 100vh;
    background-color: #2f2e33;
}
</style>